import React, { useRef, useContext, useState, useEffect, useCallback, useMemo } from "react";
import pencil from "../../assets/pencil.png";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import LogicContext from "../../Context/LogicContext";
import { permissionProfileService } from "../../services/permissionProfile.service";
import { createModal } from "react-modal-promise";
import GeneralModal from "../../helpers/GeneralModal";
import { debounce } from "lodash";
import { customerService } from "../../services/customer.service";

const ProfileAssignToUserAddNewPage = () => {
  const logicContext = useContext(LogicContext);
  const myPromiseModal = createModal(GeneralModal);

  // Main states
  const [profileDetails, setProfileDetails] = useState({ module_list_permission: [], profile_list: [] });
  const [selectedModuleId, setSelectedModuleId] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
    const [profileList, setProfileList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
  
  const [searchTerm, setSearchTerm] = useState("");
  const customerIdEdit = searchParams.get('customer_id');
  // Customer Search states
  const [searchResult, setSearchResult] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);

  const searchRef = useRef(null);
  const printRef = useRef(null);



  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  useEffect(()=> {
    if(customerIdEdit){
      loadCustomerPermissions(customerIdEdit);
    }


  },[]);

  // Load permissions 
  // for a customer
  const loadCustomerPermissions = (customerId) => {
    setSelectedUserId(customerId);
    permissionProfileService.profileAssignCustomerPermissions(customerId)
      .then((res) => {
        const serverData = res.data;
        console.log("Loaded Data:", serverData);

        if (serverData?.module_list_permission) {
            console.log('list_is_Set');
          setProfileDetails(serverData);
          setProfileList(serverData.profile_list || []); 
          
          
          // Auto-select first module that has profiles, or first module
        //   const moduleWithProfiles = serverData.module_list.find(module =>
        //     serverData.profile_list?.some(p => p.module_id === module.module_id)
        //   );

        //   const defaultModuleId = moduleWithProfiles?.module_id || serverData.module_list[0]?.module_id;
        //   setSelectedModuleId(defaultModuleId || null);
        } else {
          resetData();
        }
      })
      .catch((err) => {
        console.error("Failed to load customer permissions:", err);
        resetData();
      });
  };

  const resetData = () => {
    setProfileDetails({ module_list_permission: [], profile_list: [] });
    setSelectedModuleId(null);
     setProfileList([]); 
  };

  // Debounced Search for Customers
  const debouncedSearch = useRef(
    debounce((search) => {
      if (search.length < 3) {
        setSearchResult([]);
        setShowDropdown(false);
        return;
      }

      setLoading(true);
      customerService.getCustomerBySearch(search)
        .then((res) => {
          const results = res?.data || [];
          setSearchResult(results);
          setShowDropdown(results.length > 0);
        })
        .catch(() => {
          setSearchResult([]);
          setShowDropdown(false);
        })
        .finally(() => setLoading(false));
    }, 500)
  ).current;




  // Filter profiles for the selected module
    const filteredProfiles = selectedModuleId
      ? profileList.filter((p) => p.module_id === selectedModuleId)
      : [];
  
    const selectedModuleName = profileDetails.module_list_permission.find(
      (m) => m.module_id === selectedModuleId
    )?.module_name;
  
    const handlePermissionChange = useCallback((profileId, isChecked) => {
      setProfileList((prev) =>
        prev.map((p) =>
          p.profile_id === profileId
            ? { ...p, permission_status: isChecked ? "true" : "false" }
            : p
        )
      );
    }, []);


  const handleCustomerSelect = (customer) => {
    setSearchTerm(customer.Name || customer.Customer_Name || "");
    setShowDropdown(false);
    loadCustomerPermissions(customer.Customer_Id);
  };

  const handleSave = useCallback(async () => {
    if (!selectedModuleId) return;

    const confirm = await myPromiseModal({
      title: `${customerIdEdit ? 'Update' : 'Save'} permissions for ${selectedModuleName || 'this module'}`,
      body: "You are about to update user permissions. Continue?",
      showInput: false,
    });

    if (!confirm?.decision) return;

    const xmlItems = (profileDetails.profile_list || [])
      .map((profile) => `<a><profile_id>${profile.profile_id}</profile_id></a>`)
      .join("");

    const payload = new FormData();
    payload.set("option", 2); // 2 for NEW / Exisintg option 1
    if(customerIdEdit){
      payload.set('option', 1);
    }
    payload.set("permission_user_id", selectedUserId);
    payload.set("module_id", selectedModuleId);
    payload.set("profile_string", `<root>${xmlItems}</root>`);

    permissionProfileService.saveProfileAssignToUser(payload)
      .then((res) => {
        const response = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
        if (response.message_id === 1) {
          logicContext.showToast("Permissions saved successfully!", "success");
        } else {
          logicContext.showToast(response.message_text || "Failed to save", "error");
        }
      })
      .catch((err) => {
        console.error(err);
        logicContext.showToast("An error occurred while saving", "error");
      });
  }, [ profileDetails.profile_list, selectedModuleId, selectedModuleName, logicContext, myPromiseModal]);

  return (
    <section className="mt-4 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col lg:flex-row gap-8">
        
        {/* LEFT: Module List */}
        <div className="lg:w-2/5 bg-white shadow-xl rounded-xl p-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Modules</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Module Name
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Access
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {profileDetails.module_list_permission.map((module) => (
                  <tr
                    key={module.module_id}
                    onClick={() => setSelectedModuleId(module.module_id)}
                    className={`hover:bg-gray-50 cursor-pointer transition-colors ${
                      module.module_id === selectedModuleId ? "bg-blue-100 border-l-4 border-blue-600" : ""
                    }`}
                  >
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {module.module_name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {module.access_status}
                    </td>
                  </tr>
                ))}
                {profileDetails.module_list_permission.length === 0 && (
                  <tr>
                    <td colSpan="1" className="px-6 py-8 text-center text-gray-400">
                      No modules available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* RIGHT: Profiles Section */}
        <div ref={printRef} className="flex-1 bg-white shadow-xl rounded-xl p-6 flex flex-col">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4">
            <h1 className="text-2xl font-bold text-gray-800">
              {selectedModuleName ? `Profiles - ${selectedModuleName}` : "Select a Module"}
            </h1>

            {/* Customer Search with Dropdown */}
            <div className="relative w-full sm:w-96" ref={searchRef}>
           
              {!customerIdEdit  && 
              
                <div className="relative">
                <input
                  type="text"
                  placeholder="Search customer by name, email or phone..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    debouncedSearch(e.target.value);
                  }}
                  onFocus={() => searchResult.length > 0 && setShowDropdown(true)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                />
                <div className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400">🔍</div>
              </div>
              }
            

              {/* Search Dropdown */}
              {showDropdown && (
                <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-80 overflow-auto">
                  {loading ? (
                    <div className="p-4 text-center text-gray-500">Searching...</div>
                  ) : searchResult.length > 0 ? (
                    searchResult.map((customer, index) => (
                      <div
                        key={customer.Customer_Id || index}
                        onClick={() => handleCustomerSelect(customer)}
                        className="px-4 py-3 hover:bg-blue-50 cursor-pointer border-b last:border-b-0"
                      >
                        <div className="font-medium">{customer.Name || customer.Customer_Name}</div>
                        <div className="text-sm text-gray-500">
                          {customer.Email_Address && `${customer.Email_Address} • `}
                          {customer.Mobile}
                        </div>
                        <div className="text-xs text-gray-400">ID: {customer.Customer_Id}</div>
                      </div>
                    ))
                  ) : (
                    <div className="p-4 text-center text-gray-500">No customers found</div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Profile Table */}
          {!selectedModuleId ? (
            <div className="flex-1 flex items-center justify-center text-gray-400 text-lg py-20">
              Select a module from the left to view profiles
            </div>
          ) : (
            <>
              <div className="overflow-x-auto flex-1">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-24">Permission</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Profile Name</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-32">Access</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredProfiles.map((profile) => (
                      <tr key={profile.profile_id} className="hover:bg-gray-50">
                        <td className="px-6 py-4">
                          <input
                            type="checkbox"
                            checked={profile.permission_status === "true" || profile.permission_status === true}
                            onChange={(e) => handlePermissionChange(profile.profile_id, e.target.checked)}
                            className="w-5 h-5 accent-blue-600 cursor-pointer"
                          />
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-gray-900">
                          {profile.profile_name}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-500">
                          {profile.permission_status}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {filteredProfiles.length === 0 && (
                <div className="text-center py-16 text-gray-500">
                  {searchTerm ? `No matching profiles for "${searchTerm}"` : "No profiles available for this module"}
                </div>
              )}

              <div className="mt-8 flex justify-end">
                <button
                  onClick={handleSave}
                  className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                >
                  <img src={pencil} alt="Save" className="w-5 h-5" />
                  Save Changes
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProfileAssignToUserAddNewPage;